module.exports = __webpack_public_path__ + "static/media/icon-justification.6ce23924.svg";